<template>
  <div>
    <p class="page-title">기록요약</p>

    <div v-if="!isEmpty(record)">
      <div class="match-record">
        <ul class="info">
          <li class="emblem">
            <img :src="getEmblem(info.home_team)" alt="">
            <p>{{info.home_team_full_name}}</p>
          </li>
          <li class="vs">
            <div>vs</div>
          </li>
          <li class="emblem">
            <p>{{info.away_team_full_name}}</p>
            <img :src="getEmblem(info.away_team)" alt="">
          </li>
        </ul>
      </div>
      <div v-for="(item, index) in record" :key="index" class="record-progress">
        <ul>
          <li class="num" :class="{win: info.home_team === 'K07'}">{{item.home_score}}</li>
          <li class="text">{{item.type}}</li>
          <li class="num" :class="{win: info.away_team === 'K07'}">{{item.away_score}}</li>
        </ul>
        <div class="bar-div">
          <div class="bar left">
            <p><span :class="{win: info.home_team === 'K07'}" :style="{ width : item.home_per+'%' }"></span></p>
          </div>
          <div class="bar right">
            <p><span :class="{win: info.away_team === 'K07'}" :style="{ width : item.away_per+'%' }"></span></p>
          </div>
        </div>
      </div>
    </div>
    <MatchNotFound v-else :title="'경기 기록'" style="margin-bottom: 80px" />
  </div>
</template>

<script>
import {getEmblem, isEmpty} from '@/lib';
import MatchNotFound from '@/components/Ticket/MatchNotFound.vue';

export default {
  name: 'MatchRecord',
  components: {MatchNotFound},
  props: {
    game: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  watch: {
    game: {
      handler: function () {
        this.info = this.game;
        this.setInfo();
      },
      deep: true
    }
  },
  data() {
    return {
      info: {},
      record: []
    }
  },
  mounted() {
  },
  methods: {
    isEmpty,
    getEmblem,
    setInfo() {
      this.record = [
        {
          type: '골',
          home_score: this.info.home_team_goal,
          home_per: (this.info.home_team_goal / (this.info.home_team_goal + this.info.away_team_goal)) * 100,
          away_score: this.info.away_team_goal,
          away_per: (this.info.away_team_goal / (this.info.home_team_goal + this.info.away_team_goal)) * 100,
        }, {
          type: '슈팅',
          home_score: this.info.home_st_qty,
          home_per: (this.info.home_st_qty / (this.info.home_st_qty + this.info.away_st_qty)) * 100,
          away_score: this.info.away_st_qty,
          away_per: (this.info.away_st_qty / (this.info.home_st_qty + this.info.away_st_qty)) * 100,
        }, {
          type: '유효슈팅',
          home_score: this.info.home_st_valid_qty,
          home_per: (this.info.home_st_valid_qty / (this.info.home_st_valid_qty + this.info.away_st_valid_qty)) * 100,
          away_score: this.info.away_st_valid_qty,
          away_per: (this.info.away_st_valid_qty / (this.info.home_st_valid_qty + this.info.away_st_valid_qty)) * 100,
        }, {
          type: '파울',
          home_score: this.info.home_fo_qty,
          home_per: (this.info.home_fo_qty / (this.info.home_fo_qty + this.info.away_fo_qty)) * 100,
          away_score: this.info.away_fo_qty,
          away_per: (this.info.away_fo_qty / (this.info.home_fo_qty + this.info.away_fo_qty)) * 100,
        }, {
          type: '경고',
          home_score: this.info.home_warn_qty,
          home_per: (this.info.home_warn_qty / (this.info.home_warn_qty + this.info.away_warn_qty)) * 100,
          away_score: this.info.away_warn_qty,
          away_per: (this.info.away_warn_qty / (this.info.home_warn_qty + this.info.away_warn_qty)) * 100,
        }, {
          type: '퇴장',
          home_score: this.info.home_exit_qty,
          home_per: (this.info.home_exit_qty / (this.info.home_exit_qty + this.info.away_exit_qty)) * 100,
          away_score: this.info.away_exit_qty,
          away_per: (this.info.away_exit_qty / (this.info.home_exit_qty + this.info.away_exit_qty)) * 100,
        }, {
          type: '코너킥',
          home_score: this.info.home_CK_Qty,
          home_per: (this.info.home_CK_Qty / (this.info.home_CK_Qty + this.info.away_CK_Qty)) * 100,
          away_score: this.info.away_CK_Qty,
          away_per: (this.info.away_CK_Qty / (this.info.home_CK_Qty + this.info.away_CK_Qty)) * 100,
        }, {
          type: '프리킥',
          home_score: this.info.home_FK_St_Qty,
          home_per: (this.info.home_FK_St_Qty / (this.info.home_FK_St_Qty + this.info.away_FK_St_Qty)) * 100,
          away_score: this.info.away_FK_St_Qty,
          away_per: (this.info.away_FK_St_Qty / (this.info.home_FK_St_Qty + this.info.away_FK_St_Qty)) * 100,
        }, {
          type: '오프사이드',
          home_score: this.info.home_os_qty,
          home_per: (this.info.home_os_qty / (this.info.home_os_qty + this.info.away_os_qty)) * 100,
          away_score: this.info.away_os_qty,
          away_per: (this.info.away_os_qty / (this.info.home_os_qty + this.info.away_os_qty)) * 100,
        }, {
          type: '점유율',
          home_score: this.info.home_Team_Time_share,
          home_per: this.info.home_Team_Time_share,
          away_score: this.info.away_Team_Time_share,
          away_per: this.info.away_Team_Time_share,
        }
      ]
    },
    getRecordList() {

      // item.per = round(Math.round( (row.cnt/row.total)*100 ));
    }
  }
}
</script>
